import { CommonModule } from '@angular/common';
import {
  Component,
  inject,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { RepresentanteCardComponent } from '../../../../representantes/representante-card/representante-card.component';
import { ApiService } from '@core/providers/http';
import {
  EnumService,
  ProfissionaisRepresentacaoEmpresaService,
  ProfissionaisTipoRepresentacaoService,
} from '@app/features-modules/gestao-bolseiros/components/api/services';
import { PaginatorControlComponent } from '@app/shared/components/paginator-control/paginator-control.component';
import { CadastrarEditarRepresentanteComponent } from '../cadastrar-editar-representante/cadastrar-editar-representante.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ToastModule } from 'primeng/toast';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { InputText } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { FilterItem } from '@app/features-modules/gestao-bolseiros/components/api/models/filterItem.model';
import { Pagination } from '@app/shared/model';
import { RedefinirSenhaComponent } from '../../../../../../../../shared/components/redefinir-senha/redefinir-senha.component';

@Component({
  selector: 'app-lista-representantes',
  imports: [
    CommonModule,
    SearchBarComponent,
    RepresentanteCardComponent,
    PaginatorControlComponent,
    ToastModule,
    ConfirmDialogModule,
    DataVoidComponent,
    DialogModule,
    SelectModule,
    InputText,
    ButtonModule,
    ReactiveFormsModule,
  ],
  template: `
    <div class="input_contetnt">
      <app-search-bar
        primaryBtnLabel="Adicionar Representante"
        [showFilterBtn]="true"
        (onFilterBtnClick)="showFilter = true"
        [sortFields]="sortFields"
        (onPrimaryBtnClick)="createRepresentante()"
        (formValueChange)="onFilterChange($event)"
      ></app-search-bar>
    </div>

    @if (pagination.data?.length) {
      <div class="list mt-4">
        <div class="row">
          @for (item of pagination.data; track $index) {
            <div class="col-12">
              <app-representante-card
                [representante]="item"
                [instituicaoEnsino]="perfilEmpresa"
                (delete)="deleteRepresentante(item)"
                (edit)="editarRepresentante($event)"
                (redefinirSenha)="redefinirSenhaRepresentante($event)"
              >
              </app-representante-card>
            </div>
          }
          <div class="col-12">
            <div class="pagination-controls">
              <app-paginator-control
                [first]="
                  ((pagination.pageNumber ?? 1) - 1) *
                  (pagination.pageSize ?? 10)
                "
                [rows]="pagination.pageSize ?? 10"
                [totalRecords]="pagination.totalRecords ?? 0"
                (pageChange)="onPageChange($event)"
              >
              </app-paginator-control>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <div class="no-data">
        <app-data-void
          titulo="Nenhum Representante encontrado"
          descricao="Clique em Adicionar Representante para criar um."
        ></app-data-void>
      </div>
    }
    <p-confirmdialog></p-confirmdialog>
    <p-toast></p-toast>
    <p-dialog
      header="Filtros"
      [modal]="true"
      [(visible)]="showFilter"
      [style]="{ width: '40rem' }"
      appendTo="body"
    >
      <form [formGroup]="form" class="p-fluid grid">
        <div
          *ngFor="let filter of filters"
          class="field col-6 d-flex flex-column"
        >
          <label>{{ filter.placeholder }}</label>

          <!-- Se for dropdown -->
          <p-select
            *ngIf="filter.type === 'dropdown'"
            [filter]="true"
            [showClear]="true"
            appendTo="body"
            [options]="filter.options"
            [formControlName]="filter.controlName"
            [placeholder]="filter.placeholder"
            [optionLabel]="filter.optionLabel"
            [optionValue]="filter.optionValue"
          >
          </p-select>

          <!-- Se for texto -->
          <input
            *ngIf="filter.type === 'text'"
            pInputText
            [formControlName]="filter.controlName"
            [placeholder]="filter.placeholder"
            class="w-full"
          />
        </div>
      </form>

      <div class="flex items-center justify-content-between">
        <p-button
          label="Cancelar"
          severity="secondary"
          (click)="showFilter = false"
        />
        <p-button
          label="Pesquisar"
          (click)="handleFormValueChange(form.value)"
        />
      </div>
    </p-dialog>
  `,
  providers: [
    ApiService,
    DialogService,
    MessageService,
    ConfirmationService,
    EnumService,
    ProfissionaisRepresentacaoEmpresaService,
    ProfissionaisTipoRepresentacaoService,
  ],
  styles: ``,
})
export class ListaRepresentantesComponent implements OnInit, OnChanges {
  @Input('perfilEmpresa') perfilEmpresa: any;
  private route = inject(ActivatedRoute);
  private router = inject(Router);
  dialogService = inject(DialogService);
  messageService = inject(MessageService);
  private representacaoEmpresa = inject(
    ProfissionaisRepresentacaoEmpresaService,
  );
  isLoading = false;
  showFilter = false;
  pagination: Pagination<any> = new Pagination<any>();
  private tipoRepresentacaoService = inject(
    ProfissionaisTipoRepresentacaoService,
  );
  tiposRepresentacao: any[] = [];
  private confirmationService = inject(ConfirmationService);
  constructor(private fb: FormBuilder) {}
  form!: FormGroup;
  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'Nome',
      placeholder: 'Pesquise pelo nome do representante',
    },
    {
      type: 'dropdown',
      controlName: 'TipoRepresentacaoID',
      placeholder: 'Seleccione o tipo de representação',
      options: this.tiposRepresentacao,
      optionLabel: 'designacao',
      optionValue: 'id',
    },
  ];
  sortFields: any[] = [
    { label: 'Nome', value: 'nome' },
    { label: 'Email', value: 'email' },
    { label: 'Tipo representante', value: 'TipoRepresentacaoID' },
  ];
  representantes = [];
  representante: any;

  ngOnInit(): void {
    this.loadTiposRepresentacao();
    this.getAllRepresentantesEmpresas({
      EmpresaID: this.perfilEmpresa?.id || this.empresaID,
    });
    this.form = this.fb.group({
      Nome: [null],
      TipoRepresentacaoID: [null],
    });
  }

  showDialog() {
    const ref = this.dialogService.open(CadastrarEditarRepresentanteComponent, {
      showHeader: false,
      width: '45%',
      modal: true,
      data: {
        empresaID: this.perfilEmpresa.id,
        tipoRepresentacaoOptions: this.tiposRepresentacao,
        representante: this.representante, // Pass this if editing
      },
    });

    ref.onClose.subscribe((data) => {
      if (data) {
        this.isLoading = true; // Iniciar carregamento
        const payload = data.payload ?? data;
        const saveOperation = this.representante?.id
          ? this.representacaoEmpresa.update(payload)
          : this.representacaoEmpresa.store(payload);

        saveOperation.subscribe({
          next: (response) => {
            if (response?.retorno?.codigo === 200) {
              this.getAllRepresentantesEmpresas();
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: `Representante ${
                  payload.id ? 'editado' : 'criado'
                } com sucesso!`,
                life: 3000,
              });
            } else {
              this.messageService.add({
                severity: 'error',
                summary: 'Erro',
                detail:
                  response?.retorno?.mensagem ||
                  'Erro ao salvar o representante.',
                life: 3000,
              });
            }
            this.isLoading = false; // Parar carregamento
          },
          error: (err) => {
            console.error('Erro ao salvar o representante:', err);
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao salvar o representante.',
              life: 3000,
            });
            this.isLoading = false; // Parar carregamento
          },
        });
      }
    });
  }

  createRepresentante() {
    this.router.navigate([
      'bolsa-profissionais/empresas/add-representante',
      this.empresaID,
    ]);
  }

  editarRepresentante(representante: any) {
    this.representante = representante;
    this.showDialog();
  }

  redefinirSenhaRepresentante(representante: any) {
    const ref = this.dialogService.open(RedefinirSenhaComponent, {
      header: 'Redefinir Senha do Representante',
      width: '45%',
      showHeader: false,
      modal: true,
      data: {
        representante,
      },
    });

    ref.onClose.subscribe((data) => {
      if (data) {
        this.messageService.add({
          severity: 'success',
          summary: 'Senha redefinida',
          detail: `Senha redefinida para o usuário ${data.username}.`,
        });

        // Caso queira actualizar algo visualmente, pode fazer aqui
        // this.carregarRepresentantes();
      }
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.getAllRepresentantesEmpresas();
  }

  loadTiposRepresentacao() {
    this.tipoRepresentacaoService.list().subscribe((response) => {
      this.tiposRepresentacao = response.data;
      this.filters[1].options = this.tiposRepresentacao;
    });
  }

  onFilterChange(filters: any) {
    this.getAllRepresentantesEmpresas({
      ...filters,
      EmpresaID: this.perfilEmpresa?.id || this.empresaID,
    });
  }

  getAllRepresentantesEmpresas(filters?: any) {
    this.isLoading = true;
    const params = {
      ...filters,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 10,
      EmpresaID: this.perfilEmpresa?.id || this.empresaID,
      OrderBy: 'Id desc',
    };

    this.representacaoEmpresa.list(params).subscribe(
      (res: any) => {
        this.pagination = new Pagination<any>().deserialize(res);
        this.isLoading = false;
      },
      (error: any) => {
        console.error('Erro ao buscar empresas:', error);
        // this.messageService.add({
        //   severity: 'error',
        //   summary: 'Erro',
        //   detail: 'Erro ao buscar empresas.',
        // });
        this.isLoading = false;
      },
    );
  }

  deleteRepresentante(representante: any) {
    this.confirmationService.confirm({
      header: 'Confirmar Exclusão?',
      message: `Tem certeza que deseja excluir ${representante.nome}?`,
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        this.representacaoEmpresa.delete(representante.id).subscribe({
          next: (response) => {
            if (response.retorno?.codigo === 200) {
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: `Representante excluído com sucesso!`,
                life: 3000,
              });
              this.getAllRepresentantesEmpresas({
                EmpresaID: this.perfilEmpresa?.id || this.empresaID,
              });
            } else {
              console.error('Erro ao excluir o representante:', response);
            }
          },
          error: (err) => {
            console.error('Erro ao excluir o representante:', err);
            this.messageService.add({
              severity: 'error',
              summary: 'Erro',
              detail: 'Erro ao excluir o representante.',
              life: 3000,
            });
          },
        });
      },
    });
  }

  get empresaID(): number {
    return Number(this.route.snapshot.paramMap.get('id'));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['perfilEmpresa']) {
      this.getAllRepresentantesEmpresas({
        EmpresaID: this.perfilEmpresa?.id || this.empresaID,
      });
    }
  }

  handleFormValueChange(event: any) {
    const queryParams = Object.fromEntries(
      Object.entries(event).filter(
        ([key, value]) => value !== null && value !== '',
      ),
    );
    this.getAllRepresentantesEmpresas(queryParams);
    this.showFilter = false;
  }
}